var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKirov(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "97mm",
    height: "125mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 97 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str5{stroke:#f8c300;stroke-width:.6;stroke-linecap:round;stroke-linejoin:round}.str3{stroke-width:.8}.str2,.str3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round}.fil2{fill:none}.fil3{fill:#da251d}.fil0{fill:#f8c300}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M48.622 124.497c.702-5.79 5.616-10.274 11.6-10.274l24.539-.623c6.474 0 11.672-5.226 11.672-11.7V.502H.5V101.9c0 6.474 5.352 11.7 11.827 11.7l24.539.622c5.983 0 10.97 4.485 11.685 10.276l.07-.001z",
    style: {
      stroke: "#f8c300",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5 12.949c-3.295.338-5.8.931-8.277 3.84-6.027.745-8.956 4.05-9.317 9.48-4.522 3.215-5.993 8.172-4.413 14.873-5.313 3.328-7.44 7.452-4.907 12.74l.07 12.279c.402 1.686 1.279 3.313 2.55 4.891-3.76 6.048-2.071 11.441 5.066 14.71.026 10.258 5.747 13.172 14.056 12.749 1.093 1.461 2.813 2.581 5.105 3.39l.067-88.952z",
    style: {
      fill: "#007cc3",
      stroke: "#007cc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M96.5 12.949c-3.295.338-5.8.931-8.277 3.84-6.027.745-8.956 4.05-9.317 9.48-4.522 3.215-5.993 8.172-4.413 14.873-5.313 3.328-7.44 7.452-4.907 12.74l.07 12.279c.402 1.686 1.279 3.313 2.55 4.891-3.76 6.048-2.071 11.441 5.066 14.71.026 10.258 5.747 13.172 14.056 12.749 1.093 1.461 2.813 2.581 5.105 3.39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_38872272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_79975720",
    className: "fil3 str3",
    d: "M16.063 19.77c-3.884.959-6.805 2.346-8.99 4.103V12.255c2.185 1.757 5.106 3.144 8.99 4.102-.959-3.883-2.346-6.804-4.103-8.99h11.617c-1.757 2.186-3.144 5.107-4.103 8.99 3.884-.958 6.804-2.345 8.99-4.102v11.617c-2.186-1.757-5.106-3.144-8.99-4.103.959 3.884 2.346 6.804 4.103 8.99H11.96c1.757-2.186 3.144-5.106 4.103-8.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_79798800",
    className: "fil3 str3",
    cx: 17.768,
    cy: 4.603,
    r: 2.485
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_39436504",
    className: "fil3 str3",
    transform: "rotate(-90 11.186 6.878) scale(.95884)",
    r: 2.592
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_82826496",
    className: "fil3 str3",
    transform: "rotate(90 6.583 24.647) scale(.95884)",
    r: 2.592
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_39115032",
    className: "fil3 str3",
    cx: 17.768,
    cy: 31.525,
    r: 2.485
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M96.487 30.6c-7.85 1.008-11.448 5.558-8.836 15.282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M86.847 39.201C79.45 40.326 75.16 43.64 74.739 50.213m18.934-19.044c-.905-1.524-.475-3.402 1.128-5.513m-.899-2.574c-3.058 2.553-4.301 5.548-2.891 9.19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M84.382 34.687c-1.169 1.686-1.248 3.373-.237 5.06m-.948-8.901c-2.99 2.465-4.22 5.636-2.306 10.063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M83.36 27.945c-5.73 2.529-7.564 7.343-5.121 14.666m18.227 14.813c-2.026-1.804-2.309-3.554-.848-5.25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M96.463 61.532c-5.236-3.2-6.886-6.933-3.296-11.441"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M96.46 65.087c-8.635-4.799-11.686-10.92-3.661-17.284M96.5 90.338c-14.827-5.502-15.407-15.281-2.23-22.228"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M85.526 46.536c-9.26 8.245-11.88 17.112 1.33 27.356"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M89.196 71.467c-5.636-3.544-8.222-7.958-7.756-13.245m9.51 11.895c-3.47-2.01-5.333-5.363-7.059-8.463m4.822 2.248c.81 1.66 2.207 2.895 4.407 4.842m-5.02 8.029c-.814 4.632 2.836 7.572 8.344 9.806"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M90.797 78.121c-.14 2.389 1.866 4.122 5.65 5.312m-14.353-9.03c-3.566-.231-7.55-.899-9.889-3.35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M81.154 79.47c-1.92-1.57-2.539-3.27-1.524-5.307m-2.427-.463c-1.367 3.122-.499 5.808 2.602 8.058"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M78.58 83.31c-4.39-2.828-5.95-5.581-3.533-10.337m2.225 12.789c3.899.96 7.166.514 10.67-.337m2.078 6.752c-.289 2.812.055 4.742 1.308 6.334"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M83.973 91.197c1.664 1.797 3.31 3.106 5.955 2.983m-9.019-3.637c2.235 4.227 5.343 6.167 9.322 5.818"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M53.605 53.068H39.762l-2.043 2.37h-4.177V46.77c-11.372-9.96 4.445-17.11 9.337-29.267l10.726 35.565zm-1.748 8.102 1.163 1.937-10.14 33.628c-4.892-12.157-20.709-19.306-9.337-29.267V58.8h4.177l2.043 2.37h12.095zm2.905 3.195c2.338 1.177-.204 3.222 8.78 1.539l1.308 1.39c4.302-2.898 9.001.344 16.426 1.552-4.389-5.35-4.927-10.995-.817-16.998-4.74-.055-8.935.572-11.931 2.697h-6.293c-1.783-1.088-3.92-1.732-6.574-1.73L43.874 14.253c.092-.44.168-.885.227-1.338 1.539.763 2.942.9 4.145.033 1.657-1.194 3.395.268 7.524-.352-3.759.226-5.686-1.544-7.613-.718-1.668.715-2.895.268-3.922-.894.013-.96-.049-1.947-.208-2.968-.92-5.877-8.64-.443-2.717 1.466 2.67 15.697-27.304 25.4-14.051 38.934v7.022H13.693c.347-1.065.974-2.061 1.757-3.018-3.78 1.567-8.274 3.133-13.361 4.699 5.087 1.566 9.581 3.132 13.361 4.699-.783-.957-1.41-1.953-1.757-3.018h13.566v7.022C14.006 79.357 43.979 89.06 41.31 104.756c-5.923 1.909 1.797 7.343 2.717 1.466.16-1.02.221-2.008.208-2.968 1.027-1.162 2.254-1.61 3.922-.894 1.927.826 3.854-.944 7.613-.718-4.129-.62-5.867.841-7.524-.352-1.203-.866-2.606-.73-4.145.033a17.36 17.36 0 0 0-.227-1.338l10.888-35.62z",
    style: {
      stroke: "#fff",
      strokeWidth: 0.7,
      strokeLinejoin: "round"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M53.981 55.566c-.216.767 1.75.9 2.452.9 1.606 0 1.493.623 2.412 1.779 2.297 2.887 2.943 1.733 3.613 2.633-.69.588-2.323-1.181-2.344.96-.032 3.252 3.908 4.022 4.244.312.317-3.491-.358-4.165-2.45-6.257-.9-.9-7.34-2.403-7.927-.327z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M54.15 58.075c-1.596.204-.747 1.72.594 1.365 1.964-.52 3.668-1.91-.593-1.365zm.564 2.523c-1.102.485-.29 1.807 1.092 1.124 2.318-1.146 2.95-2.903-1.092-1.124zm1.488 1.907c-.894.55-.18 1.795 1.104.944 1.965-1.303 1.677-2.653-1.104-.944zm1.648 1.52c-.855.723.214 1.712 1.122.623 1.131-1.358-.183-1.418-1.122-.623zm17.113-5.465c-.45-3.037.91-2.238 1.041-3.654-5.766.491-6.566 1.819-4.024 5.727.477-2.07-1.214-2.578.777-3.596.017.86.317 1.896.878 2.81.32-1.106-.3-2.728.511-3.25.156.743.335 1.494.817 1.962zm-7.482 3.57c-.067-1.649.067-3.216.652-3.831.146 1.195.28 2.265 1.111 2.946-.068-2.045-.133-3.094.357-3.517-1.162-.81-1.766-1.124-2.627-1.173-.481 2.576-.254 4.577.507 5.575z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str5",
    d: "m39.709 56.343-.67.776h12.805l.67-.776z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str5",
    d: "m53.358 55.362-.845.98m-11.96-.98-.845.98m2.675-.98-.845.98m2.674-.98-.845.98m2.675-.98-.846.98m2.675-.98-.846.98m2.675-.98-.845.98m2.674-.98-.845.98"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKirov);
export default __webpack_public_path__ + "static/media/kirov.b85095435f9069f016be83b9d0681ae1.svg";
export { ForwardRef as ReactComponent };